import React, { useContext, useRef } from "react";
import StateContext from "../../state/stateContext";
import "../../assets/css/profile-section.css";
import Section from "../Section/Section";
import Expando from "../Expando/Expando";

export function ProfileSection(props) {
  const { state, dispatch } = useContext(StateContext);
  const sectionRef = useRef();
  const {
    children,
    classList = "",
    thumbnailUrl,
    name,
    collapsedText,
    expandedText,
    isLoading = false,
  } = props;

  const setExpandoStatus = (isOpen) => {
    dispatch({ type: "setExpandoStatus", payload: { profile: isOpen } });
  };

  return (
    <Section
      sectionRef={sectionRef}
      isLoading={isLoading}
      classList={`ProfileSection profile three-column__left-rail ${classList} section-container section-container__profile`}
    >
      <Expando
        thumbnailUrl={thumbnailUrl}
        collapsedText={collapsedText}
        expandedText={expandedText}
        name={name}
        setExpandoStatusCallback={setExpandoStatus}
        sectionRef={sectionRef}
      >
        {children}
      </Expando>
    </Section>
  );
}

export default ProfileSection;
